import { MessageCircle } from "lucide-react";
import { waLink, generalMsg } from "@/lib/whatsapp";

export default function WhatsAppFab() {
  return (
    <a
      href={waLink(generalMsg())}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chatear por WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 animate-bounce-subtle items-center justify-center rounded-full bg-wa text-black shadow-[0_0_24px_rgba(37,211,102,0.45)] transition-transform hover:scale-110"
    >
      <MessageCircle className="h-6 w-6" strokeWidth={2.4} />
    </a>
  );
}
